const SLIDES_PER_VIEW_RADIX = 10;
const CENTERED_SLIDES_EVEN_INCREMENT = 1;
const CENTERED_SLIDES_PARITY_DIVISOR = 2;
const CARDS_EFFECT_LOOP_MULTIPLIER = 2;

const parseSlidesPerViewValue = (value, centeredSlides = false) => {
  if (value === 'auto') return 1;

  let slidesPerView = Math.ceil(parseFloat(value, SLIDES_PER_VIEW_RADIX));
  if (!Number.isFinite(slidesPerView) || slidesPerView < 1) {
    slidesPerView = 1;
  }

  if (centeredSlides && slidesPerView % CENTERED_SLIDES_PARITY_DIVISOR === 0) {
    slidesPerView += CENTERED_SLIDES_EVEN_INCREMENT;
  }

  return slidesPerView;
};

const getLoopedSlides = ({
  slidesPerView,
  slidesPerGroup = 1,
  slidesPerGroupAuto = false,
  centeredSlides = false,
  loopAdditionalSlides = 0,
}) => {
  const slidesPerGroupValue = slidesPerGroupAuto ? slidesPerView : slidesPerGroup;
  let loopedSlides = centeredSlides
    ? Math.max(slidesPerGroupValue, Math.ceil(slidesPerView / CENTERED_SLIDES_PARITY_DIVISOR))
    : slidesPerGroupValue;

  if (loopedSlides % slidesPerGroupValue !== 0) {
    loopedSlides += slidesPerGroupValue - (loopedSlides % slidesPerGroupValue);
  }

  return loopedSlides + loopAdditionalSlides;
};

const getBreakpointConfigs = (config = {}) => {
  const { breakpoints, ...baseConfig } = config;
  if (!breakpoints || typeof breakpoints !== 'object') {
    return [baseConfig];
  }

  const configs = [baseConfig];
  let accumulated = { ...baseConfig };

  Object.keys(breakpoints)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((breakpoint) => {
      accumulated = { ...accumulated, ...breakpoints[breakpoint] };
      configs.push({ ...accumulated });
    });

  return configs;
};

const getMinSlidesForLoop = (config = {}) => {
  let maxRequirement = 0;

  getBreakpointConfigs(config).forEach((breakpointConfig) => {
    const slidesPerView = parseSlidesPerViewValue(
      breakpointConfig.slidesPerView ?? config.slidesPerView ?? 1,
      breakpointConfig.centeredSlides ?? config.centeredSlides
    );
    const loopedSlides = getLoopedSlides({
      slidesPerView,
      slidesPerGroup: breakpointConfig.slidesPerGroup ?? config.slidesPerGroup,
      slidesPerGroupAuto: breakpointConfig.slidesPerGroupAuto ?? config.slidesPerGroupAuto,
      centeredSlides: breakpointConfig.centeredSlides ?? config.centeredSlides,
      loopAdditionalSlides: breakpointConfig.loopAdditionalSlides ?? config.loopAdditionalSlides,
    });

    const requirement = slidesPerView + loopedSlides;
    maxRequirement = Math.max(maxRequirement, requirement);

    const effect = breakpointConfig.effect ?? config.effect;
    if (effect === 'cards') {
      maxRequirement = Math.max(maxRequirement, slidesPerView + loopedSlides * CARDS_EFFECT_LOOP_MULTIPLIER);
    }
  });

  return maxRequirement;
};

const sanitizeSwiperLoop = (config, slideCount) => {
  if (!config?.loop) return config;
  if (slideCount >= getMinSlidesForLoop(config)) return config;
  return { ...config, loop: false };
};

export { getMinSlidesForLoop, sanitizeSwiperLoop };
